import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import Spring from "../../components/Spring";


export const StyledSpring = styled(Spring)`
    min-height: calc(100vh - 50px);
    padding: 24px;
    background-color: ${p => p.theme.c.snow};

    h1 {
        margin-top: 0;
    }
`;

export const CardHolder = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    ${p => p.theme.md.only(css`
        grid-template-columns: 1fr 1fr 1fr;
    `)}
    ${p => p.theme.sm.only(css`
        grid-template-columns: 1fr 1fr;
    `)}
    ${p => p.theme.xs(css`
        grid-template-columns: 1fr;
    `)}
`;

export const Card = styled(Link)`
    border-radius: 8px;
    background-color: ${p => p.theme.c.cardBackground};
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow3};
    overflow: hidden;
    transition: 300ms;
    h3 {
        padding: 6px 10px;
        margin: 0;
        font-size: 20px;
        font-weight: ${p => p.theme.mode === "dark" ? 400 : 600};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    img {
        width: 100%;
        display: block;
        transition: 300ms;
    }

    .ImageHolder {
        overflow: hidden;
    }

    &:hover {
        box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow5};
        transform: scale(0.984) translateZ(0);

        img {
             transform: scale(1.04);
        }
    }
`;
